
import { MockList } from 'graphql-tools';
import {
  emails,
  properties,
  users,
  roles,
  authorized_apps
} from './mocks';

export const get_rand_mock = list => list[Math.floor(Math.random() * list.length)]

export const users_and_emails = (users, emails) => {

}

export default {
      types: {
        /*Account: () => {
          const [first_name, last_name] = get_rand_mock(users).split(' ');
          console.log('first_name: ',first_name)
          return {
            email: get_rand_mock(emails),
            first_name,
            last_name,
          }
        },*/
        AuthorizedApp: () => ({
            name: get_rand_mock(authorized_apps)
        }),
        AccountsListNode: () => ({
            email: get_rand_mock(emails),
            name: get_rand_mock(users),
        }),
      },
      query: {
        accounts: async(root, { orgId, first, after }) => {
          const wait = () => new Promise(r => setTimeout(r,500));
          await wait();
          return new MockList(15)
       },
       accountsListNode: async(root, { name }) => {
         const wait = () => new Promise(r => setTimeout(r,500));
         await wait();
         return new MockList(15)
       }
     }

}
